import { render, staticRenderFns } from "./UploadShipmentDocumentsModal.vue?vue&type=template&id=1a32c16a&scoped=true"
import script from "./UploadShipmentDocumentsModal.vue?vue&type=script&lang=js"
export * from "./UploadShipmentDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadShipmentDocumentsModal.vue?vue&type=style&index=0&id=1a32c16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32c16a",
  null
  
)

export default component.exports